@if (type === "dashboard") {
  <header
    id="header"
    class="app-header d-flex align-items-center justify-content-between ps-5 pe-4"
  >
    <div class="d-md-none flex-shrink-0">
      <a href="/" class="brand">
        <img src="logos/logo-mini-color.png" alt="" />
      </a>
    </div>
    @if (false) {
      <div
        class="search-control py-3 ps-5 pe-4 p-md-0"
        [ngClass]="isMobileSearch ? 'd-flex' : 'd-none'"
      >
        <div class="form-control form-control-sm">
          <i
            class="ph-duotone ph-magnifying-glass text-opacity-50 text-dark fs-6"
          ></i>
          <input type="text" placeholder="Search Shop" />
        </div>
        <a
          role="button"
          class="d-md-none text-opacity-75 ms-2 text-dark"
          (click)="isMobileSearch = false"
        >
          <i class="ph ph-x fs-6"></i>
        </a>
      </div>
    }
    <!-- Right side header -->
    <div class="d-flex align-items-center gap-2 gap-sm-3 ms-auto">
      @if (false) {
        <button
          class="btn btn-sm btn-icon btn-ghost-light rounded-pill d-md-none"
          (click)="isMobileSearch = true"
        >
          <i class="ph-duotone ph-magnifying-glass fs-6"></i>
        </button>
      }
      <!-- <button
        class="btn btn-sm btn-icon btn-ghost-light rounded-pill position-relative"
        (click)="openNotifications()"
        title="Notifications"
      >
        <i class="ph ph-bell fs-6"></i>
        <span
          class="position-absolute top-0 start-100 translate-middle p-1 bg-danger border border-light rounded-circle"
          style="margin-top: 6px; margin-left: -6px"
        >
          <span class="visually-hidden">New notifications</span>
        </span>
      </button> -->
      <div ngbDropdown class="d-inline-block">
        <a
          role="button"
          class="text-decoration-none fw-medium"
          id="user_profile"
          ngbDropdownToggle
        >
          <div class="avatar avatar--pill">
            <div class="avatar__image">
              <img [src]="userAvatar" alt="User" />
            </div>
          </div>
        </a>
        <div ngbDropdownMenu aria-labelledby="user_profile">
          <div class="px-3 py-2 border-bottom bg-light">
            <small class="text-muted d-block fw-semibold">{{
              user?.full_name
            }}</small>
          </div>
          <a
            ngbDropdownItem
            routerLink="/home/profile"
            class="d-flex align-items-center gap-2"
          >
            <i class="ph ph-user fs-6"></i>
            <span>Profile</span>
          </a>
          <div class="dropdown-divider my-1"></div>
          <button
            ngbDropdownItem
            class="text-danger d-flex align-items-center gap-2"
            (click)="logout()"
          >
            <i class="ph ph-sign-out fs-6"></i>
            <span>Logout</span>
          </button>
        </div>
      </div>
    </div>
  </header>
} @else {
  <header id="header" class="py-3">
    <div class="container d-flex align-items-center">
      <a href="#" class="brand">
        <img src="/logos/logo.png" class="d-none d-md-block" alt="MMCM" />
        <img src="/logos/logo-mini.png" class="d-md-none" alt="MMCM" />
      </a>
      @if (false) {
        <div class="gap-2 d-flex ms-auto">
          <button
            type="button"
            class="btn btn-mobile-icon btn-sm btn-shadow btn-primary"
          >
            <i class="ph ph-headset fs-6"></i>
            <span class="d-sm-inline-block d-none">Contact Us</span>
          </button>
          <a href="#" class="btn btn-sm btn-outline-white">
            <span>English</span>
            <i class="ph ph-caret-down fs-6"></i>
          </a>
        </div>
      }
    </div>
  </header>
}
